import React from 'react';

import { RiCarLine, RiFileTextLine, RiScales3Line } from '@remixicon/react';
import { Tabs as AntdTabs, Typography as AntdTypo } from 'antd';

import { BorderedContent } from 'components/WrappedComponents';
import { useDossierContext } from 'hooks/dossiers/DossierContext';
import { useEnvironnement } from 'hooks/EnvironementStoreContext';
import { shouldDisplayJusticeFeature } from 'utils/justice/methods';

import { Commentaires } from './Commentaires/Commentaires';
import { FicheInfraction } from './FicheInfraction/FicheInfraction';
import { FicheJudiciaire } from './FicheJudiciaire/FicheJudiciaire';
import { FicheVehicule } from './FicheVehicule/FicheVehicule';
import { SuiviFourriere } from './SuiviFourriere/SuiviFourriere';

import './Content.less';

const { TabPane } = AntdTabs;
const { Text } = AntdTypo;

export const Content = (): React.ReactElement => {
  const [{ result: dossier }] = useDossierContext();
  const [{ JUSTICE_ACTIVE_BOOL }] = useEnvironnement();

  return (
    <div className={'ContentContainer'}>
      <div className={'Tabs'}>
        <BorderedContent>
          <AntdTabs defaultActiveKey="1" animated={false} className={'AntTabs'}>
            <TabPane
              tab={
                <span>
                  <RiCarLine />
                  <Text>Informations véhicule</Text>
                </span>
              }
              key="1"
              className={'AntTabPan'}
            >
              <FicheVehicule dossier={dossier} />
            </TabPane>
            <TabPane
              tab={
                <span>
                  <RiFileTextLine />
                  <Text>Informations infraction</Text>
                </span>
              }
              key="2"
              className={'AntTabPan'}
            >
              <div className={'bordered'}>
                <FicheInfraction dossier={dossier} />
              </div>
            </TabPane>
            {shouldDisplayJusticeFeature(dossier, JUSTICE_ACTIVE_BOOL) && (
              <TabPane
                tab={
                  <span>
                    <RiScales3Line />
                    <Text>Informations judiciaires</Text>
                  </span>
                }
                key="3"
                className={'AntTabPan'}
              >
                <div className={'bordered'}>
                  <FicheJudiciaire dossier={dossier} />
                </div>
              </TabPane>
            )}
          </AntdTabs>
        </BorderedContent>
        <Commentaires />
      </div>
      <div className={'SuiviContainer'}>
        <SuiviFourriere />
      </div>
    </div>
  );
};
